import {ActionType} from "../actionTypes";
import {Action} from "../actions/flyerWithoutPageImagesActions";
import {ErrorDto} from "../../dtos";

const initialState = {
    flyerId: null,
    loading: false,
    error: null,
    type: null,
    successInfo: null
}

interface initialStateInterface {
    flyerId: null | number,
    loading: boolean,
    error: ErrorDto | null,
    type: null | string,
    successInfo: null | string;
}

export const createFlyerWithoutPageImagesReducer = (state: initialStateInterface = initialState, action: Action): initialStateInterface => {

    switch (action.type) {
        case ActionType.CREATE_FLYER_WITHOUT_PAGE_IMAGES_START: {
            return { ...state, error: null, loading: true, type: action.type, successInfo: null };
        }
        case ActionType.CREATE_FLYER_WITHOUT_PAGE_IMAGES_SUCCESS: {
            return { ...state, flyerId: action.payload, error: null, loading: false, type: action.type };
        }
        case ActionType.CREATE_FLYER_WITHOUT_PAGE_IMAGES_ERROR: {
            return { ...state, error: action.payload, loading: false, type: action.type, successInfo: null };
        }
        case ActionType.CREATE_FLYER_WITHOUT_PAGE_IMAGES_COMPLETED: {
            return { ...state, error: null, loading: false, type: action.type };
        }
        //
        default: {
            return state;
        }
    }

}